import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, inject } from '@angular/core';

@Injectable()
export class CustomErrorHandlerService implements ErrorHandler {
  private errorWrapper = inject<{ error: Error }>('ERROR_WRAPPER' as never, { optional: true });
  private injector = inject(Injector);

  handleError(error: Error) {
    if (error instanceof HttpErrorResponse) {
      const errorMessage = error.message;
      if (error.error.message === errorMessage) {
        // duplicate error, not sure why this is happening, but without this check, we will in some cases send duplicate errors to Sentry
        return;
      }
      error = error.error;
      error.message = errorMessage;
    }
    error = error['originalError'] || error['error'] || error;

    console.error(error);
    // eslint-disable-next-line no-debugger
    debugger;

    if (this.errorWrapper) {
      this.errorWrapper.error = error;
    } else {
      import('./services/sentry.service').then(({ SentryService }) => {
        const service = this.injector.get(SentryService);
        service?.captureException(error);
      });
    }
  }
}
